import React from 'react'

function Live() {
  return (
    <div>
    <button className='peer text-white lg:text-gray-700 font-semibold lg:font-normal text-center  text-md   lg:text-sm'  >Ev & Yaşam</button>
    <div className='hidden peer-hover:flex hover:flex absolute'>
      <div className='p-2 md:p-3 lg:p-4 z-20 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 border border-gray-400 lg:border-none mt-2  lg:mt-6 cursor-pointer w-80 md:w-97 text-center'>
          <div className='p-1 lg:p-2 space-x-2 grid grid-cols-2 md:grid-cols-4'>
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Mobilya</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Salon & Oturma Odası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Yatak Odası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Çalışma Odası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Bahçe & Balkon</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Çocuk Odası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Genç Odası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Mutfak</li>
          
              </ul>

              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Sofra & Mutfak</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Yemek Takımı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kahvaltı Takımı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tencere & Tava </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Bardak Seti</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Demlik & Hahve</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Fırın</li>
              
          
              </ul>
              
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Ev Tekstil</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Nevresim Takımı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Yorgan & Yastık</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kırlent Kılıfı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Perde</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Mutfak Tekstil</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Tekstil</li>
                  
          
              </ul>
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Ev Dekorasyon</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tablo</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Duvar Saati</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Ayna</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Mum & Kokular</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Dekoratif Aksesuarlar</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Küvet Filesi</li>
           
          
              </ul>

          </div>

          <div className='p-1 lg:p-2 space-x-2  grid grid-cols-2 md:grid-cols-4'>
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Aydınlatma</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Avize</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Lambader</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Abajur</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Masa Lambası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Aplik</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Ampul</li>
            
          
              </ul>

              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Ev Aletleri</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Süpürgeler</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Ütüler</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Blender </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tost Makine</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Çay Makinesi</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kahve Makinesi</li>
              
          
              </ul>
              
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Banyo</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Havlu & Havlu Seti</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Duşakabin</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Aksesuarları</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Seti</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Paspası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Tekstili</li>
                  
          
              </ul>
              <ul className='space-y-1 text-gray-700 text-xs   md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs   md:text-sm font-500 text-gray-300 underline'>Ofis & Kırtasiye</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kırtasiye Ürünleri</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Fotokobi Kağıdı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Yazıcı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Fotokobi Makineleri</li>

           
          
              </ul>

          </div>
      </div>
    </div>

  </div>
  )
}

export default Live
